import React, { useMemo } from "react";
import {
  InsuranePlanWrapper,
  Header,
  LinksWrapper,
  Link,
  Image,
  Footer,
  InsurerIcon,
  FooterElement,
  FooterButton,
  LinkNew,
  LinksWrapper2,
} from "./styles";
import moment from "moment";
import InsuranceIcon from "../../assets/svgs/shield.svg";
import GpaIcon from "../../assets/svgs/gpa_card_icon.svg";
import GtlIcon from "../../assets/svgs/gtl_card_icon.svg";
import LinkIcon from "../../assets/svgs/arrorLinkBlack2.svg";
import top_up_health from "../../assets/svgs/topup_health.svg";
import parental_cover from "../../assets/svgs/parental_cover.svg";
import ArrowBlue from "../../assets/svgs/blueArrow.svg";
import ArrowWhite from "../../assets/svgs/whiteArrow.svg";
import { CASHLESS_CLAIM_URLS } from "../../constants/businessConstant";
import { insurers } from "../memberApp/constants/PolicyConstants";
import { Ptag } from "../fonts";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const InsurancePlanCard = ({ plan_detail, details, type }) => {
  // getting insurer name
  const insurerName = details.service_provider.toUpperCase();
  const history = useHistory();

  // opening policy document
  const openPolicyDoc = () => {
    window.open(details.policy_doc_url);
  };
  const viewGradeSetup = () => {
    // window.open(details.employee_policy_doc_url);
    history.push("/business/view-grade-setup", {
      state: { useplanId: details.userplan_id },
    });
  };
  const newBenefitManual = () => {
    window.open(details.employee_policy_doc_url);
  };
  const vierClaimSupport = () => {
    history.push("/business/claim-support");
  };

  // opening cashless url based on insurer
  const cashlessClaimHandler = () => {
    if (insurerName.includes("NIVA BUPA")) {
      window.open(CASHLESS_CLAIM_URLS.NIVA);
    } else if (insurerName.includes("KOTAK")) {
      window.open(CASHLESS_CLAIM_URLS.KOTAK);
    } else if (insurerName.includes("ICICI LOMBARD")) {
      window.open(CASHLESS_CLAIM_URLS.ICICI);
    } else if (insurerName.includes("GO_DIGIT")) {
      window.open(CASHLESS_CLAIM_URLS.DIGIT);
    } else if (insurerName.includes("TATA_AIG")) {
      window.open(CASHLESS_CLAIM_URLS.TATA);
    } else {
      window.open(CASHLESS_CLAIM_URLS.DEFAULT);
    }
  };

  // displaying header icon based on product
  const icon = useMemo(() => {
    let blob = "";
    switch (type) {
      case "GPA":
        blob = GpaIcon;
        break;
      case "GTL":
        blob = GtlIcon;
        break;
      case "top_up_health":
        blob = top_up_health;
        break;
      case "parental_cover":
        blob = parental_cover;
        break;
      default:
        blob = InsuranceIcon;
        break;
    }
    return blob;
  }, [type]);

  return (
    <InsuranePlanWrapper>
      <div style={{ padding: "20px 24px 16px 24px" }}>
        <Header style={{ justifyContent: "space-between", height: "4rem" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={icon} width="36px" />
            <Ptag
              fontSize="18px"
              fontWeight="500"
              color="#436AB2"
              marginLeft="1rem"
            >
              {plan_detail.title}
            </Ptag>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginRight: "1rem",
            }}
          >
            <Ptag fontSize="8px" fontWeight="600" textAlign="center">
              POWERED BY
            </Ptag>
            <InsurerIcon
              src={
                insurers && insurers[insurerName] && insurers[insurerName].logo
              }
            />
          </div>
        </Header>
        <Ptag
          // maxwidth="80%"
          fontSize="16px"
          fontWeight="400"
          marginTop="1.4rem"
          // marginBottom="1.4rem"
          letterHeight="24px"
        >
          {plan_detail.description}
        </Ptag>
        {/* {details.group_policy_number && (
          <div style={{ display: "flex" }}>
            <Ptag>Policy Number :&nbsp;</Ptag>
            <Ptag fontWeight="700"> {details.group_policy_number || "-"}</Ptag>
          </div>
        )} */}
      </div>
      <LinksWrapper>
        {details.employee_policy_doc_url && (
          <Link onClick={newBenefitManual}>
            <Ptag fontSize="14px" fontWeight="600" color="#0054E3">
              Employee Benefit Manual
            </Ptag>
            <Image src={ArrowBlue} />
          </Link>
        )}
      </LinksWrapper>
      <div>
        <FooterElement>
          <FooterButton style={{ borderBottomLeftRadius: "inherit" }}>
            <LinkNew onClick={openPolicyDoc}>
              <div style={{ maxWidth: "65%" }}>
                <Ptag fontSize="14px" fontWeight="600" color="white">
                  Policy Schedule
                </Ptag>
              </div>
              <Image src={ArrowWhite} />
            </LinkNew>
          </FooterButton>

          <FooterButton
            style={{
              borderBottomRightRadius:
                plan_detail.title !== "Group Mediclaim Cover" ? "inherit" : "",
            }}
          >
            <LinkNew onClick={viewGradeSetup}>
              <div style={{ maxWidth: "44%" }}>
                <Ptag fontSize="14px" fontWeight="600" color="white">
                  Plan Setup
                </Ptag>
              </div>
              <Image src={ArrowWhite} />
            </LinkNew>
          </FooterButton>
          {plan_detail.title == "Group Mediclaim Cover" && (
            <FooterButton style={{ borderBottomRightRadius: "inherit" }}>
              {
                // details.flat_or_graded === "GRADED" &&
                <LinkNew
                  onClick={vierClaimSupport}
                  style={{ alignItems: "end" }}
                >
                  <div style={{ maxWidth: "65%" }}>
                    <Ptag fontSize="14px" fontWeight="500" color="white">
                      Claims Support
                    </Ptag>
                  </div>
                  <Image src={ArrowWhite} />
                </LinkNew>
              }
            </FooterButton>
          )}
        </FooterElement>
      </div>
    </InsuranePlanWrapper>
  );
};

export default InsurancePlanCard;
